 
const DOMAIN_API = window.location.hostname.includes('.com') ? 'https://app.canaldoanuncio.com': 'http://canaldoanuncio.test';
const BASE_URL =  `${DOMAIN_API}/api/v1`

export { DOMAIN_API, BASE_URL }